import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import './AuthPage.css';

export default function RegisterPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    first_name: '', last_name: '', email: '', password: '', confirm_password: '', phone: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm_password) {
      setError('Passwords do not match.');
      return;
    }
    if (form.password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/auth/register', {
        first_name: form.first_name,
        last_name: form.last_name,
        email: form.email,
        password: form.password,
        phone: form.phone
      });
      // Don't log in yet — redirect to email verification first
      navigate('/verify', {
        state: {
          email: form.email,
          token: res.data.token,
          user: res.data.user,
        }
      });
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      <Header />
      <main className="main-content auth-main">
        <div className="auth-container auth-container-wide">
          <div className="auth-card">
            <div className="auth-header">
              <div className="auth-seal">USCIS</div>
              <h1>Create Account</h1>
              <p>Begin your Gold Card application</p>
            </div>

            {error && <div className="auth-error">{error}</div>}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label" htmlFor="first_name">First Name *</label>
                  <input id="first_name" type="text" name="first_name" className="form-input"
                    value={form.first_name} onChange={handleChange} required placeholder="John" />
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="last_name">Last Name *</label>
                  <input id="last_name" type="text" name="last_name" className="form-input"
                    value={form.last_name} onChange={handleChange} required placeholder="Smith" />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="reg-email">Email Address *</label>
                <input id="reg-email" type="email" name="email" className="form-input"
                  value={form.email} onChange={handleChange} required placeholder="you@example.com" />
              </div>
              <div className="form-group">
                <label className="form-label" htmlFor="phone">Phone Number</label>
                <input id="phone" type="tel" name="phone" className="form-input"
                  value={form.phone} onChange={handleChange} placeholder="+1 (555) 000-0000" />
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label" htmlFor="password">Password *</label>
                  <input id="password" type="password" name="password" className="form-input"
                    value={form.password} onChange={handleChange} required placeholder="Min. 8 characters" />
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="confirm_password">Confirm Password *</label>
                  <input id="confirm_password" type="password" name="confirm_password" className="form-input"
                    value={form.confirm_password} onChange={handleChange} required placeholder="Repeat password" />
                </div>
              </div>

              <div className="auth-disclaimer">
                By creating an account, you agree that the information provided will be subject to
                DHS verification as part of the I-140G Gold Card vetting process.
              </div>

              <button type="submit" className="btn btn-primary auth-submit-btn" disabled={loading}>
                {loading ? 'Creating Account…' : 'Create Account & Apply'}
              </button>
            </form>

            <div className="auth-footer">
              <p>Already have an account? <Link to="/login">Sign In</Link></p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}